import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=5f691cda&"
import script from "./SidebarContent.vue?vue&type=script&lang=js&"
export * from "./SidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=5f691cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports